'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;
var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');
var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
var _createClass2 = require('babel-runtime/helpers/createClass');
var _createClass3 = _interopRequireDefault(_createClass2);
var _class;
var _d = require('d3');
var _d2 = _interopRequireDefault(_d);
var _accessors = require('./accessors');
var _accessors2 = _interopRequireDefault(_accessors);
var _accessors3 = require('../choropleth/accessors');
var _accessors4 = _interopRequireDefault(_accessors3);
var _computors = require('../choropleth/computors');
var _computors2 = _interopRequireDefault(_computors);
var _computors3 = require('./computors');
var _computors4 = _interopRequireDefault(_computors3);
var _eauors = require('./eauors');
var _eauors2 = _interopRequireDefault(_eauors);
var _accessors5 = require('../map/accessors');
var _accessors6 = _interopRequireDefault(_accessors5);
var _selectors = require('./selectors');
var _selectors2 = _interopRequireDefault(_selectors);
var _options = require('../utils/options');
var _options2 = _interopRequireDefault(_options);
var _utils = require('../utils');
var _ramda = require('ramda');
var R = _interopRequireWildcard(_ramda);
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var ChoroplethLegend = (0, _eauors2.default)(_class = (0, _computors4.default)(_class = (0, _accessors2.default)(_class = (0, _selectors2.default)(_class = (0, _computors2.default)(_class = (0, _accessors4.default)(_class = (0, _accessors6.default)(_class = function () {
  function ChoroplethLegend(el) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    (0, _classCallCheck3.default)(this, ChoroplethLegend);
    this.options = (0, _options2.default)(options, el);
    _constructor(el, this.options, data, {
      accessors: this.constructor.accessors,
      computors: this.constructor.computors,
      eauors: this.constructor.eauors,
      selectors: this.constructor.selectors
    });
  }
  (0, _createClass3.default)(ChoroplethLegend, [{
    key: 'update',
    value: function update(el) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      this.options = (0, _options2.default)(options, el);
      _update(el, this.options, data, {
        accessors: this.constructor.accessors,
        computors: this.constructor.computors,
        eauors: this.constructor.eauors,
        selectors: this.constructor.selectors
      });
    }
  }]);
  return ChoroplethLegend;
}()) || _class) || _class) || _class) || _class) || _class) || _class) || _class;
exports.default = ChoroplethLegend;
function _constructor(el, options, data, ors) {
  (0, _utils.noElError)(el);
  _d2.default.select(el).call(_utils.setupElement, 'svg:svg', ors.selectors.legend).select((0, _utils.selector)(ors.selectors.legend)).call(_utils.setupElement, 'svg:g', ors.selectors.axis);
  _update(el, options, data, ors);
}
function _update(el, options, data, ors) {
  if (process.env.NODE_ENV !== 'production') {
    console.time(_utils.prefix + ' ChoroplethLegend#_update');
  }
  var domain = ors.computors.domain(options, data);
  if (R.isNil(domain) || R.any(R.anyPass([R.isNil, function (v) {
    return isNaN(v);
  }]))(domain) || R.head(domain) === R.last(domain)) {
    _d2.default.select(el).select((0, _utils.selector)(ors.selectors.legend)).attr({
      width: 0,
      height: 0
    });
    _d2.default.select(el).selectAll((0, _utils.selector)(ors.selectors.colors)).remove();
    _d2.default.select(el).select((0, _utils.selector)(ors.selectors.legend)).selectAll('.tick').remove();
    _d2.default.select(el).select((0, _utils.selector)(ors.selectors.legend)).selectAll('path').remove();
    if (process.env.NODE_ENV !== 'production') {
      console.timeEnd(_utils.prefix + ' ChoroplethLegend#_update');
    }
    return;
  }
  var legend = _d2.default.select(el).select((0, _utils.selector)(ors.selectors.legend)).call(ors.eauors.legendUpdate, options, ors.accessors);
  var axis = ors.computors.axis(options, data);
  var axisSvg = legend.select((0, _utils.selector)(ors.selectors.axis)).call(ors.eauors.axisEnter, axis, options, ors.computors);
  var offset = ors.computors.axisOffset(axisSvg, options);
  axisSvg.call(ors.eauors.axisUpdate, options, offset, ors.computors);
  var colorsJoin = legend.selectAll((0, _utils.selector)(ors.selectors.colors)).data(ors.computors.colorBars(options, data, offset));
  colorsJoin.enter().call(ors.eauors.colorEnter, ors.selectors);
  colorsJoin.call(ors.eauors.colorUpdate);
  colorsJoin.exit().remove();
  if (process.env.NODE_ENV !== 'production') {
    console.timeEnd(_utils.prefix + ' ChoroplethLegend#_update');
  }
}